import CustomAxiosInstance from "../middlewares/axios/connectionErrorMiddleware";
import { routeGroupEndpoints } from "../helpers/requests/apiEndpoints";
import { formatSerbiaTime } from "../config/dayjsConfig";

const api = CustomAxiosInstance();

const methods = {
  getRouteGroups: (payload) =>
    api
      .get(
        routeGroupEndpoints.getRouteGroupsUrl.replace(
          "{date}",
          formatSerbiaTime(payload)
        )
      )
      .then((res) => res.data),
  getForCopyRouteGroups: (payload) =>
    api
      .get(
        routeGroupEndpoints.getForCopyRouteGroupsUrl.replace(
          "{date}",
          formatSerbiaTime(payload)
        )
      )
      .then((res) => res.data),
  createRouteGroup: (payload) =>
    api
      .post(routeGroupEndpoints.createRouteGroupUrl, payload)
      .then((res) => res.data),
  updateRouteGroup: (payload) =>
    api
      .put(
        routeGroupEndpoints.updateRouteGroupUrl.replace("{id}", payload.id),
        payload.payload
      )
      .then((res) => res.data),
  addRouteToRouteGroup: (payload) =>
    api
      .put(
        routeGroupEndpoints.addRouteToRouteGroupUrl.replace("{id}", payload.id),
        payload.payload
      )
      .then((res) => res.data),
  deleteRouteFromRouteGroup: (payload) =>
    api
      .put(
        routeGroupEndpoints.deleteRouteFromRouteGroupUrl.replace(
          "{id}",
          payload.id
        ),
        payload.payload
      )
      .then((res) => res.data),
  deleteRouteGroup: (payload) =>
    api
      .delete(routeGroupEndpoints.deleteRouteGroupUrl.replace("{id}", payload))
      .then((res) => res.data),
  copyRouteGroupToClipboard: (payload) =>
    api
      .get(routeGroupEndpoints.copyRouteGroupToClipboardUrl, {
        params: payload,
      })
      .then((res) => res.data),
};

export default methods;
